export default __webpack_public_path__ + "static/media/touch.97de7fa0.svg";